"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiService = void 0;
var axios_1 = __importDefault(require("axios"));
var uuid_1 = require("uuid");
var config_1 = require("../config");
// eslint-disable-next-line
var window_1 = __importDefault(require("../utils/window"));
function request(_a) {
    var _b;
    var method = _a.method, _c = _a.headers, headers = _c === void 0 ? {} : _c, body = _a.body, rest = __rest(_a, ["method", "headers", "body"]);
    return __awaiter(this, void 0, void 0, function () {
        var auth, updatedHeaders, token, data, error_1, response, config, _d, useRedirectCheck, checkAuthEndpoint, err_1, _e, loginUrl, redirectParam, _f, loginUrl, redirectParam;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 4, , 11]);
                    auth = config_1.configService.getConfig().auth;
                    updatedHeaders = __assign({ 'Content-Type': 'application/json', 'X-Trace-Token': (0, uuid_1.v4)() }, headers);
                    if (!(auth && auth.getCustomerAccessToken)) return [3 /*break*/, 2];
                    return [4 /*yield*/, auth.getCustomerAccessToken()];
                case 1:
                    token = _g.sent();
                    updatedHeaders.authorization = "Bearer ".concat(token.accessToken.value);
                    _g.label = 2;
                case 2: return [4 /*yield*/, (0, axios_1.default)(__assign({ data: body, responseType: 'json', method: method, headers: __assign({}, updatedHeaders), withCredentials: true }, rest))];
                case 3:
                    data = (_g.sent()).data;
                    return [2 /*return*/, data];
                case 4:
                    error_1 = _g.sent();
                    response = error_1.response;
                    if (!(response && response.status === 401)) return [3 /*break*/, 10];
                    config = config_1.configService.getConfig();
                    if (!config.auth || !config.auth.loginUrl || !config.auth.redirectParam) {
                        throw new Error('Config not set correctly, missing config.auth.loginUrl and config.auth.redirectParam');
                    }
                    _d = config.auth, useRedirectCheck = _d.useRedirectCheck, checkAuthEndpoint = _d.checkAuthEndpoint;
                    if (!(useRedirectCheck && checkAuthEndpoint)) return [3 /*break*/, 9];
                    _g.label = 5;
                case 5:
                    _g.trys.push([5, 7, , 8]);
                    return [4 /*yield*/, (0, axios_1.default)({
                            method: 'GET',
                            url: config.auth.checkAuthEndpoint,
                            headers: {
                                'X-Trace-Token': (0, uuid_1.v4)(),
                            },
                            withCredentials: true,
                        })];
                case 6:
                    _g.sent();
                    // if auth response is 200, don't redirect since token is still valid
                    console.error('401 error received with valid token');
                    return [3 /*break*/, 8];
                case 7:
                    err_1 = _g.sent();
                    if (((_b = err_1.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                        _e = config.auth, loginUrl = _e.loginUrl, redirectParam = _e.redirectParam;
                        window_1.default.location.href = "".concat(loginUrl, "?").concat(redirectParam, "=").concat(encodeURIComponent(window_1.default.location.href));
                    }
                    else {
                        // problem calling the auth endpoint
                        console.error("Error calling auth endpoint: ".concat(err_1));
                    }
                    return [3 /*break*/, 8];
                case 8: return [3 /*break*/, 10];
                case 9:
                    _f = config.auth, loginUrl = _f.loginUrl, redirectParam = _f.redirectParam;
                    window_1.default.location.href = "".concat(loginUrl, "?").concat(redirectParam, "=").concat(encodeURIComponent(window_1.default.location.href));
                    _g.label = 10;
                case 10: return [2 /*return*/, Promise.reject(error_1)];
                case 11: return [2 /*return*/];
            }
        });
    });
}
function get(options) {
    return request(__assign({ method: 'GET' }, options));
}
function post(options) {
    return request(__assign({ method: 'POST' }, options));
}
function put(options) {
    return request(__assign({ method: 'PUT' }, options));
}
function patch(options) {
    return request(__assign({ method: 'PATCH' }, options));
}
function del(options) {
    return request(__assign({ method: 'DELETE' }, options));
}
function graphql(options) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, data, errors, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, post(options)];
                case 1:
                    _a = _b.sent(), data = _a.data, errors = _a.errors;
                    if (errors) {
                        // For now, catch any errors from graphql.
                        return [2 /*return*/, Promise.reject(errors)];
                    }
                    return [2 /*return*/, data];
                case 2:
                    error_2 = _b.sent();
                    return [2 /*return*/, Promise.reject(error_2)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
var apiService = {
    get: get,
    post: post,
    patch: patch,
    put: put,
    delete: del,
    graphql: graphql,
};
exports.apiService = apiService;
